export const bios = [
  {
    id: 1,
    name: 'Alice',
    title: 'Archivist and Digital Asset Manager',
  },
  {
    id: 2,
    name: 'Chrissy',
    title: 'Digital Archives Associate',
  },
  {
    id: 3,
    name: 'Harry',
    title: 'Web Developer',
  },
  {
    id: 4,
    name: 'Henry',
    title: 'Senior Graphic Designer',
  },
  {
    id: 5,
    name: 'Jacob',
    title: 'Environmental Design Manager',
  },
  {
    id: 6,
    name: 'Juan',
    title: 'Digital Desinger',
  },
  {
    id: 7,
    name: 'Karla',
    title: 'Senior Program Administrator',
  },
  {
    id: 8,
    name: 'Megan',
    title: 'Strategic Communications Manager',
  },
  {
    id: 9,
    name: 'Morgan',
    title: 'Newsroom Coordinator',
  },
];